import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("Redirect")
export class Redirect implements AxInit {
    private InitData: RedirectInitData;

    private RedirectTimeout;

    constructor(private _AxLoading = new AxLoading()) {
    }

    AxInit(init: RedirectInitData): void {
        this.InitData = init;
        this._AxLoading.ShowLoadingIndicator(document.querySelector('.redirect__loading'));

        this.RedirectTimeout = setTimeout(() => {
            this.Redirect();
        }, 2000);

        $('.redirect__page a').click(e => {
            e.preventDefault();
            clearTimeout(this.RedirectTimeout);
            this.Redirect();
        });
    }

    Redirect() {
        window.location.href = this.InitData.Link;

        setTimeout(() => {
            //window.location.href = "https://google.com";
        }, 500);

        setTimeout(() => {
            $('.redirect_content').addClass('d-none');
            $('.redirect_alt').addClass('d-none');
            $('.redirect_failed').removeClass('d-none');
        }, 2000);
    }
}

interface RedirectInitData {
    Link: string;
    AfterRedirect: string;
}